export default "__VITE_ASSET__DmvBfEDW__"